<template>
  <ul class="customer-labels">
    <li v-for="(attribute, index) in bad" :key="`bad${index}`" class="bad">{{ attribute }}</li>
    <li v-for="(attribute, index) in good" :key="`good${index}`">{{ attribute }}</li>
  </ul>
</template>

<script>
/**
 * お客様特徴ラベル
 */
export default {
  name: 'CustomerLabels',
  props: {
    /** 良い特徴 */
    good: Array,
    /** 悪い特徴 */
    bad: Array,
  },
}
</script>

<style lang="postcss" scoped>
.customer-labels {
  display: grid;
  grid-auto-flow: column;
  grid-gap: 8px;
  justify-content: flex-start;

  li {
    background-color: var(--pure-orange);
    box-sizing: border-box;
    color: var(--white);
    font-size: 13px;
    height: 16px;
    line-height: 1.34;
    margin-top: 4px;
    min-width: 48px;
    padding: 0 4px;
    text-align: center;

    &.bad {
      background-color: var(--pure-red);
    }
  }

  .responsive & {
    @media screen and (--sp-modal) {
      display: flex;
      flex-wrap: wrap;

      li {
        margin-right: 8px;
      }
    }
  }
}
</style>
